import { useState, useEffect } from 'react';

const navItems = [
  { label: '석면 개요', href: '#overview' },
  { label: '조사·농도측정', href: '#inspection' },
  { label: '해체·제거', href: '#removal' },
  { label: '해체·제거 감리', href: '#supervision' },
  { label: '안전관리', href: '#safety' },
  { label: '상담문의', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);

      const sections = navItems.map((item) => item.href.replace('#', ''));
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && window.scrollY >= el.offsetTop - 120) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.getElementById(href.replace('#', ''));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        <a href="#" className="flex items-center gap-3" onClick={(e) => handleNavClick(e, '#')}>
          <div className="w-[72px] h-[72px] flex items-center justify-center overflow-hidden rounded-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/0a72c82b-1978-4629-9d58-3e5964b2fb2a.png"
              alt="로고"
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <div className={`leading-tight ${scrolled ? 'text-green-950' : 'text-white'}`}>
              <span className="text-sm font-bold">석면 전문기업 </span>
              <span className="font-bold" style={{ fontSize: '21px' }}>(주)소담이앤씨</span>
            </div>
            <div className={`text-xs leading-tight ${scrolled ? 'text-green-700' : 'text-green-200'}`}>
              ASBESTOS PROFESSIONAL
            </div>
          </div>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeSection === item.href.replace('#', '')
                  ? scrolled
                    ? 'bg-green-800 text-white'
                    : 'bg-white/20 text-white'
                  : scrolled
                  ? 'text-stone-700 hover:text-green-800 hover:bg-green-50'
                  : 'text-white/90 hover:text-white hover:bg-white/15'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          className={`lg:hidden cursor-pointer ${scrolled ? 'text-green-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-100 shadow-lg">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="block px-6 py-4 text-sm font-medium text-stone-700 hover:bg-green-50 hover:text-green-800 cursor-pointer border-b border-stone-50 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
